import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { NAV_ITEMS, COMPANY_INFO } from "@/constants/nav";
import rkgLogo from "@/assets/rkg-logo-80.png";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer-container" className="bg-[#0A2540] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5 mb-5">
            <img src={rkgLogo} alt="RKG NATURALS" className="h-10 w-auto" />
          </div>
          <p className="text-sm text-white/60 leading-relaxed">{COMPANY_INFO.businessType}</p>
          <p className="text-sm text-white/60 mt-3">Owner &amp; Founder: {COMPANY_INFO.owner}</p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Quick Links</h4>
          <ul className="space-y-2.5">
            {NAV_ITEMS.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  data-testid={`footer-${item.testId}`}
                  className="text-sm text-white/70 hover:text-white transition-colors"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Contact</h4>
          <ul className="space-y-3">
            <li data-testid="footer-phone" className="flex items-start gap-2.5 text-sm text-white/70">
              <Phone className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />
              <a href={COMPANY_INFO.whatsappLink} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                {COMPANY_INFO.whatsappDisplay}
              </a>
            </li>
            <li data-testid="footer-email-primary" className="flex items-start gap-2.5 text-sm text-white/70">
              <Mail className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />
              <a href={`mailto:${COMPANY_INFO.emailPrimary}`} className="hover:text-white break-all">
                {COMPANY_INFO.emailPrimary}
              </a>
            </li>
            <li data-testid="footer-email-secondary" className="flex items-start gap-2.5 text-sm text-white/70">
              <Mail className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />
              <a href={`mailto:${COMPANY_INFO.emailSecondary}`} className="hover:text-white break-all">
                {COMPANY_INFO.emailSecondary}
              </a>
            </li>
            <li data-testid="footer-address" className="flex items-start gap-2.5 text-sm text-white/70">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />
              <a href={COMPANY_INFO.mapsLink} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                {COMPANY_INFO.address}
              </a>
            </li>
            <li data-testid="footer-hours" className="flex items-start gap-2.5 text-sm text-white/70">
              <Clock className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />
              <span>Working Hours: {COMPANY_INFO.workingHours}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Company</h4>
          <p className="text-sm text-white/70">{COMPANY_INFO.name}</p>
          <p className="text-sm text-white/60 mt-1">{COMPANY_INFO.domain}</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p data-testid="footer-copyright" className="text-xs text-white/50">
            © {year} {COMPANY_INFO.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
